import { useEffect } from "react";

export default function SEOHead({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (name, val, prop = false) => {
      if (!val) return null;
      const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.head.querySelector(sel);
      const created = !el;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(prop ? "property" : "name", name);
        document.head.appendChild(el);
      }
      const prev = el.getAttribute("content");
      el.setAttribute("content", val);
      return { el, prev, created };
    };

    const changes = [
      setMeta("description", description),
      setMeta("og:title", title, true),
      setMeta("og:description", description, true),
      setMeta("og:url", canonical, true),
      setMeta("twitter:title", title),
      setMeta("twitter:description", description),
    ].filter(Boolean);

    const link = document.head.querySelector('link[rel="canonical"]');
    const prevHref = link ? link.getAttribute("href") : null;
    if (link && canonical) link.setAttribute("href", canonical);

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "city");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
      changes.forEach(({ el, prev, created }) => {
        if (created) el.remove();
        else if (prev !== null) el.setAttribute("content", prev);
      });
      if (link && prevHref) link.setAttribute("href", prevHref);
      if (script) script.remove();
    };
  }, [title, description, canonical, jsonLd]);

  return null;
}
